import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink as RouterLink } from 'react-router-dom';
import { Paper, Box, Typography, Divider, List, ListItem, ListItemButton, ListItemAvatar, Avatar, ListItemText } from '@mui/material';
import { listEmployees } from '../../modules/empModule/employees';

const UserListContainer = () => {
    const dispatch = useDispatch();

    const { employees, error, loading } = useSelector(
        ({ empModule, loading }) => ({
            employees: empModule.employees.employees,
            error: empModule.employees.error,
            loading: loading['employee/LIST_EMPLOYEES'],
        }),
    );

    useEffect(() => {
        if (!employees) {
            dispatch(listEmployees());
        }

    }, [employees, dispatch]);


    if (error) {
        return <div>에러가 발생하였습니다. 관리자에게 문의하여 주십시오.</div>
    }

    if (loading || !employees) {
        return null;
    }


    return (
        <Paper>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    backgroundColor: '#424242',
                    color: '#fff',
                    py: 1,
                    px: 2
                }}
            >
                {/* <Box sx={{ mx: 2 }}>
                <AccountTreeIcon />
            </Box> */}
                <Typography variant="subtitle2" component="div">
                    사원 리스트
                </Typography>
            </Box>
            <Divider />

            <Box sx={{
                width: '360px'

            }}>
                <List sx={{ width: '100%', height: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                    {employees && employees.map((employee, index) => (
                        <ListItem key={index} dense divider={index === employee.length - 1 ? false : true} >
                            <ListItemButton
                                component={RouterLink}
                                to={`/usermenumng/${employee.id}`}
                                end
                                style={({ isActive }) => ({ background: isActive ? '#1769aa' : '', color: isActive ? '#fff' : '' })}

                            >
                                <ListItemAvatar>
                                    {employee.profileImg ? (<Avatar alt={employee.usrNm} src={employee.profileImg} />) : (<Avatar>{employee?.usrNm.substring(0, 1)}</Avatar>)}
                                </ListItemAvatar>
                                <ListItemText 
                                    primary={<Typography variant="body2" component="div">{employee.usrNm} {employee.gradeNm} ({employee.dptNm})</Typography>} 
                                    secondary={<Typography variant="body2" component="div">{employee.emlAddr}</Typography>} 
                                />
                            </ListItemButton>
                        </ListItem>

                    ))}
                </List>
            </Box>
        </Paper>
    )
}

export default UserListContainer